var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0686035,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88687 4.0686C4.39722 4.0686 4 4.4537 4 4.92814V15.2085C4 15.683 4.39727 16.0678 4.88687 16.0678H15.1131C15.603 16.0678 16 15.6829 16 15.2084V4.92814C16 4.4537 15.603 4.0686 15.1131 4.0686H4.88687ZM7.64659 8.70829V14.1104H5.8509V8.70829H7.64659ZM7.76495 7.03764C7.76495 7.55604 7.37518 7.97086 6.74912 7.97086L6.73735 7.97081C6.13468 7.97081 5.74506 7.556 5.74506 7.03759C5.74506 6.50743 6.14645 6.10419 6.76102 6.10419C7.37518 6.10419 7.75323 6.50743 7.76495 7.03764ZM10.4361 14.1104H8.64052C8.64052 14.1104 8.66406 9.21525 8.64062 8.70848H10.4362V9.47312C10.6749 9.1051 11.1021 8.58164 12.0546 8.58164C13.236 8.58164 14.1217 9.35376 14.1217 11.013V14.1104H12.3262V11.2207C12.3262 10.4944 12.0662 9.99909 11.4166 9.99909C10.9204 9.99909 10.625 10.3331 10.4952 10.6559C10.4478 10.771 10.4361 10.9327 10.4361 11.0939V14.1104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fddf0f69667feb3a46c2270f144029fc.svg";
export { ForwardRef as ReactComponent };